export function formatSellerNames(names) {
  if (!Array.isArray(names) || !names.length) return '';

  if (names.length === 1) {
    return names[0];
  } else if (names.length === 2) {
    return `${names[0]} and ${names[1]}`;
  } else {
    const allExceptLast = names.slice(0, -1).join(', ');
    const last = names[names.length - 1];
    return `${allExceptLast} and ${last}`;
  }
}
